/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CharityUserDto = {
    id?: string;
    email?: string;
    first_name?: string;
    last_name?: string;
    phone?: string;
    role?: CharityUserDto.role;
    status?: CharityUserDto.status;
};
export namespace CharityUserDto {
    export enum role {
        SUPPORTER = 'SUPPORTER',
        SOLICITOR = 'SOLICITOR',
        CHARITY = 'CHARITY',
        SUPER_ADMIN = 'SUPER_ADMIN',
        ADMIN = 'ADMIN',
        READ_ONLY = 'READ_ONLY',
    }
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
        PENDING = 'PENDING',
        VERIFICATION = 'VERIFICATION',
        SUSPENDED = 'SUSPENDED',
    }
}

